export interface FilterProps {
  filters?: {
    companies?: string[],
    tags?: string[],
  }
}

export const isValidFilter = (filters: string[] | undefined, value: string | string[]) => {
  return !filters || filters.length === 0 || (Array.isArray(value) ? filters.every(v => value.includes(v)) : filters.includes(value));
};